import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// TODO can't finish until client returns the filters
export default function OPageTitle({ label }) {
	return (
		<section className="o-filter-product o-filter-product--title">
			<p>
				<FormattedMessage id={label} />
			</p>
		</section>
	);
}

OPageTitle.propTypes = {
	label: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.page-title.js